import styled from 'styled-components';

const TrustpilotCard = styled.div`
	background: ${p => p.theme.ui.surface};
	border-radius: ${p => p.theme.borderRadius.large};
	padding: 24px;
`;

export default TrustpilotCard;
